import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import PeopleIcon from '@mui/icons-material/People';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import ROUTES from 'constants/routes';

const MENU_ROUTES = [
  {
    title: 'Компании',
    link: ROUTES.COMPANIES,
    icon: <BusinessIcon />,
  },
  {
    title: 'Пользователи',
    link: ROUTES.USERS,
    icon: <PeopleIcon />,
  },
  {
    title: 'Карты компетенций',
    link: ROUTES.COMPETENCY_MAPS,
    icon: <EmojiObjectsOutlinedIcon />,
  },
  {
    title: 'Логи',
    link: ROUTES.LOGS,
    icon: <ArticleOutlinedIcon />,
  },
  {
    title: 'Баг-репорты',
    link: ROUTES.BUG_REPORTS,
    icon: <ReportProblemOutlinedIcon />,
  },
];

export default MENU_ROUTES;
